<template>
  <a-tag v-if="state === EmailState.try" class="try">En Bandeja</a-tag>
  <a-tag v-if="state === EmailState.assigned" class="assigned">Asignado</a-tag>
  <a-tag v-if="state === EmailState.resolved" class="resolved">Resuelto</a-tag>
</template>

<script>
import { EmailState } from "@/app/shared/utils/enums";

export default {
  props: {
    state: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      EmailState,
    };
  },
};
</script>

<style lang="sass" scoped>
.try
  background-color: $gray-2
  color: $gray-9
  border-color: $gray-5
  width: fit-content

.assigned
  background-color: $green-1
  color: $green-6
  border-color: $green-3
  width: fit-content

.resolved
  background-color: $cyan-1
  color: $cyan-6
  border-color: $cyan-3
  width: fit-content
</style>
